// extracted by mini-css-extract-plugin
export default {"images":"ImagesList_images__QY6BO"};